import type { LuckRow } from "@averagejoesff/shared";
import type { PeopleLookup } from "./people";
import { ManagerLink } from "./people";
import { recordText, signed, tone } from "./luckFormat";

interface LuckTableProps {
  rows: readonly LuckRow[];
  people: PeopleLookup;
  myId: string | null;
}

/** Luckiest first: actual record, the wins their scores should have earned, and the gap. */
export function LuckTable({ rows, people, myId }: LuckTableProps) {
  // Bars are scaled to the luckiest/unluckiest manager shown, with a floor so a quiet week doesn't blow up tiny gaps.
  const widest = Math.max(1, ...rows.map((row) => Math.abs(row.luck)));
  return (
    <div className="table-scroll">
      <table className="standings luck-table">
        <caption className="visually-hidden">Luck by manager, luckiest first</caption>
        <thead>
          <tr>
            <th scope="col">Manager</th>
            <th scope="col" className="standings__num">
              Record
            </th>
            <th scope="col" className="standings__num">
              Expected wins
            </th>
            <th scope="col" className="standings__num">
              Luck
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => {
            // Colour and the spoken label follow the number actually shown, so +0.1 is never called "at expected".
            const shown = Number(row.luck.toFixed(1));
            return (
              <tr key={row.personId} className={row.personId === myId ? "standings__row standings__row--me" : "standings__row"}>
                <td className="standings__team">
                  <ManagerLink personId={row.personId} people={people} />
                </td>
                <td className="standings__num">{recordText(row.actual)}</td>
                <td className="standings__num">{row.expectedWins.toFixed(1)}</td>
                <td className={`standings__num luck--${tone(shown, 0)}`}>
                  <span className="luck-bar" aria-hidden="true">
                    <span
                      className={row.luck < 0 ? "luck-bar__fill luck-bar__fill--below" : "luck-bar__fill"}
                      style={{ width: `${(Math.abs(row.luck) / widest) * 50}%` }}
                    />
                  </span>
                  <span className="luck-bar__value">{signed(row.luck, 1)}</span>
                  <span className="visually-hidden"> wins {shown > 0 ? "above" : shown < 0 ? "below" : "at"} expected</span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
